// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-survey {
  display: flex;
  flex-direction: column;
}

.page-survey .page-description {
  font-weight: 400;
  font-size: 16px;
  line-height: normal;
  text-align: center;

  margin-bottom: 40px;
}

.survey-options-container {
  display: flex;
  flex-direction: column;
  gap: 16px;

  width: 100%;
  padding-bottom: 60px;
}

/*!* tablet *!*/
/*@media (max-width: 768px) {*/
/*  .survey-options-container {*/
/*    width: 100%;*/
/*    margin: 0;*/
/*  }*/
/*}*/

/*!* mobile *!*/
/*@media (max-width: 600px) {*/
/*  .survey-options-container {*/
/*    width: 100%;*/
/*    margin: 0;*/
/*  }*/
/*}*/

.survey-options-container.with-image {
  width: 70%;
  margin: 0 auto;
  padding-bottom: 90px;
}

  .survey-options-container.with-image {
    width: 60%;
    margin: 0;
  }

.page-survey .background-image-container {
  position: absolute;
  bottom: 0;
  right: 0;
}

.page-survey .background-image-container img {
  max-width: 500px;
  margin-left: auto;
  z-index: 0;
}

@media (orientation: landscape) {
  .page-survey .background-image-container img {
    max-width: 70%;
  }
}

/* tablet */
@media (max-width: 768px) {
  .page-survey .background-image-container img {
    max-width: 74%;
  }
}

.page-survey .button-container {
  width: 264px;
  box-sizing: border-box;
  margin: 40px auto 60px;
}

/*.page-survey .button-container.float {*/
/*  position: fixed;*/
/*  bottom: 30px;*/
/*  left: calc(50% - 163.5px); !* 327/2 *!*/
/*  z-index: 10;*/
/*  margin: 0;*/
/*}*/
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/base.survey.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;;EAElB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET,WAAW;EACX,oBAAoB;AACtB;;AAEA,eAAe;AACf,8BAA8B;AAC9B,gCAAgC;AAChC,mBAAmB;AACnB,iBAAiB;AACjB,MAAM;AACN,IAAI;;AAEJ,eAAe;AACf,8BAA8B;AAC9B,gCAAgC;AAChC,mBAAmB;AACnB,iBAAiB;AACjB,MAAM;AACN,IAAI;;AAEJ;EACE,UAAU;EACV,cAAc;EACd,oBAAoB;AACtB;;EAEE;IACE,UAAU;IACV,SAAS;EACX;;AAEF;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA,WAAW;AACX;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC,qBAAqB;AACrB,kBAAkB;AAClB,2CAA2C;AAC3C,iBAAiB;AACjB,eAAe;AACf,IAAI","sourcesContent":[".page-survey {\n  display: flex;\n  flex-direction: column;\n}\n\n.page-survey .page-description {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: normal;\n  text-align: center;\n\n  margin-bottom: 40px;\n}\n\n.survey-options-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  width: 100%;\n  padding-bottom: 60px;\n}\n\n/*!* tablet *!*/\n/*@media (max-width: 768px) {*/\n/*  .survey-options-container {*/\n/*    width: 100%;*/\n/*    margin: 0;*/\n/*  }*/\n/*}*/\n\n/*!* mobile *!*/\n/*@media (max-width: 600px) {*/\n/*  .survey-options-container {*/\n/*    width: 100%;*/\n/*    margin: 0;*/\n/*  }*/\n/*}*/\n\n.survey-options-container.with-image {\n  width: 70%;\n  margin: 0 auto;\n  padding-bottom: 90px;\n}\n\n  .survey-options-container.with-image {\n    width: 60%;\n    margin: 0;\n  }\n\n.page-survey .background-image-container {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n\n.page-survey .background-image-container img {\n  max-width: 500px;\n  margin-left: auto;\n  z-index: 0;\n}\n\n@media (orientation: landscape) {\n  .page-survey .background-image-container img {\n    max-width: 70%;\n  }\n}\n\n/* tablet */\n@media (max-width: 768px) {\n  .page-survey .background-image-container img {\n    max-width: 74%;\n  }\n}\n\n.page-survey .button-container {\n  width: 264px;\n  box-sizing: border-box;\n  margin: 40px auto 60px;\n}\n\n/*.page-survey .button-container.float {*/\n/*  position: fixed;*/\n/*  bottom: 30px;*/\n/*  left: calc(50% - 163.5px); !* 327/2 *!*/\n/*  z-index: 10;*/\n/*  margin: 0;*/\n/*}*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
